import { ReactNode } from 'react';

import { SensitiveValue } from './SensitiveValue';

type Formatter<T> = (value: T) => ReactNode;

// is nullish, but not 0
const isBlank = (x: unknown) => x === undefined || x === null || x === '';

export const sensitiveValueAttribute =
  <T,>({ innerFormat, label }: { innerFormat?: Formatter<T>; label?: string } = {}): Formatter<T> =>
  (val: T) => (
    <SensitiveValue label={label} isBlank={isBlank(val)}>
      {innerFormat ? innerFormat(val) : (val as ReactNode)}
    </SensitiveValue>
  );
